import React from 'react';
import ReactDOM from 'react-dom/client';
// @ts-ignore
import { initializeMagnetosphere } from '@boomi/magnetosphere';
import '@boomi/exosphere/dist/styles.css';
import '@boomi/exosphere/dist/exo-component-theme.css';
import '@boomi/exosphere/dist/exo-table-styles.css';
import '@boomi/magnetosphere/dist/global-styles.css';
// eslint-disable-next-line import/extensions
import '@boomi/exosphere/dist/icon.js';
import { I18nextProvider } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18next from 'i18next';
import App from './App';
import reportWebVitals from './reportWebVitals';
import english from './translations/en.json';
import japanese from './translations/ja.json';
import './crypto-polyfill';

initializeMagnetosphere();
i18next.use(LanguageDetector).init({
  interpolation: { escapeValue: false }, // React already does escaping
  fallbackLng: 'en',
  detection: {
    order: ['cookie', 'navigator', 'querystring'], lookupCookie: 'LOCALE', lookupQuerystring: 'locale',
  },
  resources: {
    en: {
      common: english,
    },
    ja: {
      common: japanese,
    },
  },
});

const mountApp = () => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );
  root.render(
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>,
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <I18nextProvider i18n={i18next}>
    <App />
  </I18nextProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const unmountApp = () => {
  root.unmount();
};

const BoomiAIUI = {
  mountApp,
  unmountApp,
};

declare global {
  interface Window {
    BoomiAIUI?: any;
  }
}

window.BoomiAIUI = BoomiAIUI;
